const filter = document.querySelector('.filter') as HTMLElement;
const filterButtons = document.querySelectorAll('.button--filter') as NodeListOf<HTMLAnchorElement>;
const articles = document.querySelectorAll('.listing-page__article') as NodeListOf<HTMLElement>;
const urlParams = new URLSearchParams(window.location.search);

// Add the active class to the selected filter button
function makeActive(button: HTMLAnchorElement): void {
    button.classList.add('button--active');
    button.setAttribute('aria-current', 'true');
}

// Set the default filter
function setDefaultFilter(): void {
    const filterQueryString: string | null = urlParams.get('filter');

    if (filterButtons.length > 0) {
        if (!filterQueryString) {
            makeActive(filterButtons[0]);
        }
        else if (filterQueryString) {
            // Loop through the filter buttons and set the active class to the button that matches the query string
            filterButtons.forEach((button: HTMLAnchorElement) => {
                const buttonText = button.textContent?.trim();

                if (filterQueryString === buttonText) {
                    makeActive(button);
                }
            });

            scrollIntoView(filter);
        }
    }
}

// Scroll to the first article if the take query string is present
function scrollNextElementIntoView(): void {
    const takeQueryString: string | null = urlParams.get('take');

    if (takeQueryString && articles.length > 0) {
        const firstArticle = articles[parseInt(takeQueryString, 10)];
        scrollIntoView(firstArticle);
    }
}

// Scroll to element
function scrollIntoView(element: HTMLElement): void {
    const headerElementHeight = (document.querySelector(".header") as HTMLHeadElement).scrollHeight;
    window.scrollTo({top: element.offsetTop - headerElementHeight, behavior: 'smooth'});
}

setDefaultFilter();
scrollNextElementIntoView();